import { useContext } from "react";
import { Dialog, DialogContent, IconButton, Grid } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import styles from "./styles.module.css";
import ShopContext from "../../../context/ShopContext";
import { roundOff } from "../../../helpers/NumberFormatHelper";

export default function ItemOptionsDialog({ open, item, onClose, onAdd }) {
  const { selectedShop } = useContext(ShopContext);

  const options = item?.config?.product_options || [];

  const handleAddOption = (option) => {
    onAdd(item, { price: option.price, option });
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      PaperProps={{
        sx: {
          borderRadius: "23px",
          maxWidth: "800px",
          width: "100%",
        },
      }}
    >
      <DialogContent className={styles.dialogContent}>
        <Grid container alignItems="center" justifyContent="space-between" mb={0}>
          <h3 className={styles.title}>Options</h3>
          <IconButton onClick={onClose} size="small" aria-label="close">
            <CloseIcon />
          </IconButton>
        </Grid>

        <div className={styles.optionsGrid}>
          {options.map((option, index) => (
            <div
              key={index}
              className={styles.optionCard}
              onClick={() => handleAddOption(option)}
              role="button"
              tabIndex={0}
            >
              <div className={styles.optionHeader}>
                <div className={styles.optionName}>
                  {item.name} - {option.label}
                </div>
                <div className={styles.optionStock}>
                  Stock {item.stock} {item.unit}
                </div>
              </div>

              <div className={styles.optionFooter}>
                <div className={styles.optionPrice}>
                  <div className={styles.rupeeIcon}>{selectedShop?.currency_symbol}</div>
                  {roundOff(option.price)}
                </div>
                <button
                  type="button"
                  className={styles.addBtn}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleAddOption(option);
                  }}
                  aria-label={`Add ${option.label}`}
                >
                  <AddIcon sx={{ fontSize: 20 }} />
                </button>
              </div>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
